import {
  LevelGranulometry,
  LevelGranulometryWithBearingRelativeSections
} from '../../LevelGranulometry';

export const getLevelWithBearingRelativeSectionsContent = (
  levelGranulometry: LevelGranulometry | LevelGranulometryWithBearingRelativeSections
): LevelGranulometryWithBearingRelativeSections['content'] =>
  (levelGranulometry.content || []) as LevelGranulometryWithBearingRelativeSections['content'];
